<template>
  <div class="section home-wx">
    <home-title title="文学库" clickTitle @toList="toBaseList">
      <div class="cate" slot="cate">
        <span :class="{ 'active': cateIndex == index }" v-for="(item, index) in cate" :key="index"
          @click="cateIndex = index; getList()">{{ item.name }}</span>
      </div>
    </home-title>

    <div class="container">
      <div class="flex start">
        <div class="home-wx-recomand">
          <div class="label">推荐</div>
          <div class="recomand-con">
            <div class="book-sww" v-if="bookList && bookList.length > 0">
              <swiper :options="options" ref="myswiper">
                <swiper-slide v-for="(item, index) in bookList" :key="index">
                  <div class="pic">
                    <img :src="item.cover_img" alt="" @error="imgError(item)">
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination"></div>
            </div>
            <div class="book-info" v-if="curBookInfo" @click="goRead(curBookInfo)">
              <h3>{{ curBookInfo.title }}</h3>
              <div class="author ellipsis" :title="curBookInfo.author" v-if="curBookInfo.author">{{ curBookInfo.author }}</div>
              <div class="des">{{ curBookInfo.introduce }}</div>
            </div>
          </div>
          <div class="btn" @click="goRead(curBookInfo)">点击阅读</div>
        </div>
        <div class="home-wx-recent">
          <div class="title">最近更新</div>
          <Loading v-if="loading"></Loading>
          <card-table :list="list" :category="cate && cate[cateIndex].id" showMulType />
          <empty v-if="empty"></empty>
        </div>
      </div>
      <div class="flex jc">
        <div class="homeBottomMoreBtn" @click="toMore">
          <em>查看更多</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from './home-title.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper"
import CardTable from '@/pages/literature/components/CardTable.vue'
import colums from '@/colums/colums'
import { Empty } from "element-ui";
import Loading from '@/components/common/loading.vue'
var vm;
export default {
  components: { homeTitle, swiper, swiperSlide, CardTable, Empty, Loading },
  name: 'wxk',
  props: {},
  data() {
    return {
      options: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        breakpointsInverse: true,
        autoplay: true,
        loop: true,
        grabCursor: true,
        on: {
          progress: function (progress) {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 2) * 0.3 + 1;
              } else {
                modify = 0.5625
              }
              // modify = (Math.abs(slideProgress) - 2) * 0.6 + 1.2;
              var translate = slideProgress * modify * 160 + 'px';
              var scale = 1 - Math.abs(slideProgress) / 10;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform('translateX(' + translate + ') scale(' + scale + ')');
              slide.css('zIndex', zIndex);
              slide.css('opacity', 1);
              if (Math.abs(slideProgress) > 2) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition: function (transition) {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition);
            }
          },
          slideChange() {
            vm.curBookIndex = this.realIndex
          }

        },
        pagination: {
          el: ".book-sww .swiper-pagination",
          clickable: true
        }

      },
      colums: colums.literatureCate,
      bookList: [],

      list: [],
      pageIndex: 1,
      pageSize: 9,
      cate: null,
      cateIndex: 0,
      subCate: [],
      loading: true,
      empty: false,
      curBookIndex: 0,
      swiper: null,
    }
  },
  computed: {
    curBookInfo() {
      if (this.bookList) {
        return this.bookList[this.curBookIndex]
      }
    }
  },
  created() {
    vm = this
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      let list = JSON.parse(JSON.stringify(this.colums))
      list.unshift({
        name: '综合',
        id: -1,
        labelid: -1,
      })
      this.cate = list
      this.getAllSubCate()
    },
    async getAllSubCate() {
      let allRequest = []
      this.cate.map(t => {
        if (t.labelid > 0) {
          allRequest.push(this.$api.channelApi.getChannel({ parentId: t.labelid }))
        }
      })
      let res = await Promise.all(allRequest)
      let list = []
      res.map(t => { list = list.concat(t.data) })
      this.subCate = list
      this.getRecomandBook();
      this.getList()
    },

    async getList() {
      this.empty = false
      let params = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        category: this.cate[this.cateIndex].id, //节目分类id,2,4,6,8,10
        is_award: -1, //是否获奖 1，-1
        recommend: 1,
      };
      const res = await this.$api.literatureApi.getList(params)
      const list = res.data || []
      this.loading = false
      this.list = list.map(t => {
        if (t.type_id && !t.type_name) {
          let obj = this.subCate.find(v => { return v.id == t.type_id })
          obj && (t.type_name = obj.name)
        }
        if (t.category) {
          let obj = this.cate.find(v => { return t.category == v.id })
          if (obj) {
            t.category_name = obj.name
            t.path = obj.path
          }
        }
        t.cover_img = res.showpath + t.cover_img
        return {
          ...t,
          author: this.$utils.fixedAuthor(t.listasv)
        }
      })
      if (this.list.length == 0) { this.empty = true }
    },

    async getRecomandBook() {
      let obj = this.cate.find(t => { return t.name == '小说' })
      let params = {
        page: 1,
        pageSize: 3,
        category: obj.id, //节目分类id,2,4,6,8,10
        is_award: -1, //是否获奖 1，-1
        recommend: 1,
      };
      const res = await this.$api.literatureApi.getList(params)
      let bookList = res.data || []
      bookList = await Promise.all(
        bookList.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_320,h_440`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );

      this.bookList = bookList.map(t => {
        return {
          ...t,
          author: this.$utils.fixedAuthor(t.listasv)
        }
      })
      this.initswiper()
    },

    initswiper() {
      const _t = this
      if (this.$refs.myswiper && this.$refs.myswiper.swiper) {
        this.swiper = this.$refs.myswiper.swiper
        this.swiper.init() // 现在才初始化
      } else {
        setTimeout(() => {
          _t.initswiper()
        }, 100)
      }
    },
    toBaseList() {
      this.$router.push('/literature')
    },
    toMore() {
      const path = this.cate[this.cateIndex].path || '/literature'
      this.$router.push(path)
    },
    goRead(item) {
      this.$router.push("/book/" + item.id)
    }
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/_config";
.home-wx {
  .container {
    &::after {
      content: "";
      position: absolute;
      right: -285px;
      top: 420px;
      background: url("/images/moon.png") center no-repeat;
      width: 158px;
      height: 158px;
    }
    .home-wx-recomand {
      background: url("/images/bookBg.png") center no-repeat;
      background-size: cover;
      h3 {
        transition: all 0.3s;
      }
      .book-info {
        cursor: pointer;
        &:hover {
          h3 {
            color: $main-color;
          }
        }
      }
    }
  }
}
</style>